import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ResultStatus } from '@api/model/models';

@Component({
    selector: 'app-command-execution-result',
    templateUrl: './command-execution-result.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CommandExecutionResultComponent {
    public ResultStatusType = ResultStatus;
    @Input() public resultStatus: ResultStatus;
}
